import { Component } from 'react';
import track from 'react-tracking';
import { Row } from '@simplywallst/ui-core';
import { HoldingList } from '@/components/DeprecatedPortfolio/components/Holdings/components/HoldingList';
import { NoHoldings } from '@/components/DeprecatedPortfolio/components/Holdings/components/NoHoldings';
import { SectionTitle } from '@components/ReportSectionHeader';
import type { ComputedPortfolioHolding } from '@/components/DeprecatedPortfolio/redux/interface';
import {
  MutedHeader,
  SearchAndAddHoldingWrapper,
  HoldingsReportSection,
} from './styled';
import type { DeleteHoldingModalPayload } from '@/components/DeprecatedPortfolio/components/DeleteHoldingModal/redux';
import loadable from '@loadable/component';

const DeprecatedSearchAndAddHolding = loadable(
  () => import('@components/DeprecatedSearchAndAddHolding')
);

export interface Props {
  isEditable?: boolean;
  isPortfolioLinked?: boolean;
  sectionNumber: number;
  currentHoldingCount: number | null;
  holdings: ComputedPortfolioHolding[] | null;
  isWatchlist: boolean;
  portfolioWithNoTransactions: boolean;
  portfolioId: string | null;
  excludedCompanyCount: number;
  handleFetchPortfolioItems: (
    portfolioId: string,
    isEditable?: boolean
  ) => void;
  handleDelete: (data: DeleteHoldingModalPayload) => void;
  handleEditTransactions: (data: { itemId: string }) => void;
}

@track({
  type: 'track',
  subject: 'holdings',
})
class Holdings extends Component<Props> {
  static defaultProps = {
    isEditable: false,
    isPortfolioLinked: false,
  };

  componentDidMount() {
    const { isEditable, portfolioId, handleFetchPortfolioItems } = this.props;
    if (portfolioId && handleFetchPortfolioItems) {
      /** A non-editable portfolio means it's public or shared */
      handleFetchPortfolioItems(portfolioId, isEditable);
    }
  }

  render() {
    const {
      sectionNumber,
      currentHoldingCount,
      isPortfolioLinked,
      holdings,
      isWatchlist,
      portfolioWithNoTransactions,
      portfolioId,
      excludedCompanyCount,
      handleDelete,
      isEditable,
      handleEditTransactions,
    } = this.props;
    const canShowAddCompany = isEditable && !isPortfolioLinked;
    const holdingCount = currentHoldingCount
      ? '(' + currentHoldingCount + ')'
      : '';

    return (
      <HoldingsReportSection sectionNumber={sectionNumber}>
        <Row
          as="header"
          justifyContentMd="space-between"
          alignContentMd="center"
          column={true}
          rowMd={true}
        >
          <SectionTitle>
            Holdings <MutedHeader>{holdingCount}</MutedHeader>
          </SectionTitle>
          {canShowAddCompany && portfolioId && (
            <SearchAndAddHoldingWrapper>
              <DeprecatedSearchAndAddHolding portfolioId={portfolioId} />
            </SearchAndAddHoldingWrapper>
          )}
        </Row>
        {holdings && holdings.length > 0 ? (
          <HoldingList
            isEditable={isEditable}
            isPortfolioLinked={isPortfolioLinked as boolean}
            holdingList={holdings}
            isWatchlist={isWatchlist}
            portfolioWithNoTransactions={portfolioWithNoTransactions}
            portfolioId={portfolioId}
            excludedCompanyCount={excludedCompanyCount || 0}
            handleDelete={handleDelete}
            handleEditTransactions={handleEditTransactions}
          />
        ) : (
          <NoHoldings />
        )}
      </HoldingsReportSection>
    );
  }
}

export default Holdings;
